import { apiFetch } from './api';

/** Recherche globale : toutes les entités, groupées, chacune avec son lien. */
export function rechercher(q) {
  return apiFetch(`/recherche?q=${encodeURIComponent(q)}`);
}

/**
 * Personnes (formateurs, participants, clients, interlocuteurs de demandes) qui
 * répondent à la recherche : nom, adresse, société — pour les suggestions « @ ».
 */
export function rechercherPersonnes(q) {
  return apiFetch(`/recherche/personnes?q=${encodeURIComponent(q)}`);
}

/** Villes de France dont le nom commence par `q` (liste de choix des formulaires). */
export function rechercherVilles(q) {
  return apiFetch(`/villes?q=${encodeURIComponent(q)}`);
}
